module.exports = "/static/assets/d71f8d3c085db74f2418d62915e6977a.png";